<template>
  <div class="loader">
    <div class="loader__icon"></div>
    <div class="loader__status" v-if="status">{{ status }}</div>
  </div>
</template>

<script>
export default {
  name: 'loading-spinner',
  props: {
    status: {
      required: false,
      type: String
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/component-utils.sass'
$base-line-height: 60px
$spin-duration: 1s
$pulse-duration: 750ms

@keyframes spin
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)

.loader
  position: fixed
  background: #fff
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 800
  &__icon
    position: relative
    left: 50%
    top: 50%
    margin-top: -($base-line-height/2)
    margin-left: -($base-line-height/2)
    border-radius: 50%
    width: $base-line-height
    height: $base-line-height
    border: .25rem solid $color-main
    border-top-color: $color-main-dark
    animation: spin $spin-duration infinite linear
  &__status
    position: absolute;
    left: 50vw;
    top: calc(50vh + 60px);
    transform: translate(-50%);
    font-weight: bold;
  &__progress
    background: $signable-secondary-4-shade-2
    width: 100%
    position: absolute
    bottom: 0
    left: 0
    padding: $spacing-small
    &__bar
      transition: width .25s ease
      padding: $spacing-small
      background: $color-main
      position: absolute
      top: 0
      left: 0
    &__percent
      position: absolute
      z-index: 1
      font-weight: bold
  &--absolute
    position: absolute

</style>
